<div class="loading-dots f-ac" :class="{ 'p-tx2': hasTopPadding }"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>